import { render, staticRenderFns } from "./AssessData.vue?vue&type=template&id=5e30d318&scoped=true"
import script from "./AssessData.vue?vue&type=script&lang=js"
export * from "./AssessData.vue?vue&type=script&lang=js"
import style0 from "./AssessData.vue?vue&type=style&index=0&id=5e30d318&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e30d318",
  null
  
)

export default component.exports